import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';

const languageOptions = [
    { key: 'ar', value: 'ar', flag: 'ps', text: 'Arabic', link: '/ar-lang' },
    { key: 'tr', value: 'tr', flag: 'tr', text: 'Turkish', link: '/tr-lang' },
    { key: 'en', value: 'en', flag: 'us', text: 'English', link: '/en-lang' },
    { key: 'de', value: 'de', flag: 'de', text: 'German', link: '/de-lang' },
    { key: 'es', value: 'es', flag: 'es', text: 'Spanish', link: '/es-lang' },
    { key: 'fr', value: 'fr', flag: 'fr', text: 'French', link: '/fr-lang' },
];

function LanguageSelector() {
    const handleLanguageChange = (e, { value }) => {
        const language = languageOptions.find(lang => lang.value === value);
        if (language) {
            window.open(language.link, '_self');
        }
    };

    return (
        <div className="language-selector" style={{ paddingTop: '5px' }}>
            <Dropdown
                icon={null}
                trigger={(
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '4px', 
                        cursor: 'pointer',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        transition: 'background-color 0.2s'
                    }}>
                        <Icon name='world' style={{ color: '#fff', margin: 0, fontSize: '16px' }} />
                        <Icon name='dropdown' style={{ color: '#fff', margin: 0, fontSize: '12px' }} />
                    </div>
                )}
                floating
                options={languageOptions}
                onChange={handleLanguageChange}
                pointing='top right'
                style={{
                    backgroundColor: 'transparent',
                    border: 'none'
                }}
            />
        </div>
    );
}

export default LanguageSelector;
